import * as React from 'react';
import { Styled } from './character-counter.styles';
export const CharacterCounter = ({ currentCount, maxCount, }) => (React.createElement(Styled.CharacterCounter, { "$maxCountReached": currentCount > maxCount, size: "xsmall" },
    currentCount,
    "/",
    maxCount));
//# sourceMappingURL=character-counter.js.map